import {PlayerReduxState} from "../types";
import {isAnyUserInputAction} from "../utils";
import getCurrentScenario from "./getCurrentScenario";

export default function getRepeatFromIndex(state: PlayerReduxState, index?: number): number | null {
  if (index === undefined) {
    index = state.index;
  }

  const actions = getCurrentScenario(state).actions;

  for (let i = index - 1; i >= 0; i--) {
    const action = actions[i];

    if (isAnyUserInputAction(action)) {
      return i + 1;
    }
  }

  return actions[0] ? 0 : null;
}
